export const ITEM_STATUS = {
  New: 1,
  Used: 2,
  Damaged: 3,
  Lost: 4,
  Disposed: 5,
  Reserved: 6,
  Returned: 7,
};
